(window as any).global = window;
import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;
